<jml-lib-cron-editor [(ngModel)]="cronExpression" [options]="cronOptions"></jml-lib-cron-editor>

<p-button [label]="saveButtonLabel" icon="pi pi-check" (click)="ref.close(cronExpression)"></p-button>
